import { getTenantId, setLocalTenantId } from "@/lib/storeManager";
import { getProjectTenantId } from "./config";

/** Ensure X-Tenant-Id is available for all A1 API calls on the public Jivandhara site. */
export function initializeProjectTenant(): void {
  const envTenantId = getProjectTenantId();
  if (!envTenantId) {
    return;
  }

  const stored = getTenantId();
  if (stored !== envTenantId) {
    setLocalTenantId(envTenantId);
  }
}
